import ApiBack from "../../../../utils/domains/ApiBack";
import IPS from "../../../../models/Ips";
import IPSView from "../../../../models/ipsView";
import Municipio from "../../../../models/municipio";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ServicePrivate from "../../../../services/ServicePrivate";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { MessageToastify } from "../../../../utils/funtions/MessageToastify";
import { useForm } from "../../../../utils/hooks/useForm";
import { useRef } from "react";
import Deparment from "../../../../models/Deparment";
import User from "../../../../models/user";
import { jwtDecode } from "jwt-decode";
import DateFilterButtons from "../../../component/DateFilterButtons";
import Pacts from "../../../../models/Pacts";

export const ViewPacts = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [process, setProcess] = useState<boolean>(false);
    const [selectedIpsName, setselectedIpsName] = useState<string>("");
    const [dateContract, setDateContract] = useState("");
    const [dateUpdate2025, setDateUpdate2025] = useState("");
    const [arrayPacts, setArrayPacts] = useState<Pacts[]>([]);
    const [show, setShow] = useState(false);
    const [showData, setShowData] = useState(false);
    const [show2, setShow2] = useState(false);
    const [showUpdate, setShowUpdate] = useState(false);
    const [showUpActivation, setShowUpActivation] = useState(false);
    type formaHtml = React.FormEvent<HTMLFormElement>;
    const handleCloseData = () => setShowData(false);
    const handleClose2 = () => setShow2(false);
    const formRef = useRef<HTMLFormElement>(null);
    const [arrayMunicipio, setArrayMunicipio] = useState<Municipio[]>([]);
    const [haveActualization, setHaveActialization] = useState(false);
    const [dataA, setDataA] = useState("");
    const [connectiono, setConnection] = useState("");
    const [passwordServer, setPasswordServer] = useState("");
    const [nameServer, setNameServer] = useState("");
    const [passwordConnection, setPasswordConnection] = useState("");
    const [arrayIPS, setArrayIPS] = useState<IPS[]>([]);
    //function to error the Token on the time, using when token is invalid or expired
    const [search, setSearch] = useState("");
    const [arrayUsers, setArrayUsers] = useState<User>();
    const [resumen, setResumen] = useState<any>({});
    const [objIps, setObjIps] = useState<IPS>();
    const [arrayIPSUpdate, setArrayIPSUpdate] = useState<IPS[]>([]);
    const [page, setPage] = useState(1);
    const [isSearchTriggered, setIsSearchTriggered] = useState(false);

    const [sprogramming, setProgramming] = useState("");
    const [dateConciliation, setDateCommitment] = useState("");
    const [sattendance, setSattendance] = useState("");
    const [sattendanceBool, setSattendanceBool] = useState(false);


    let { id, date_pact, attendance, num_certificate, agreement, date_agreement, type_debt, value_pact, reconciliation_amount_erp, reconciliation_amount_ebp, gloss_acepted_ebp, gloss_corrected_erp, gloss_unresolved, value_reconciled, date_commitment_payment, value_payment, is_active, id_conciliation, doubleLink, object } =
        useForm<Pacts>(
            new Pacts(
                0,
                "",
                true,
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                0
            ) // Incluye `id_municipio` con un valor inicial
        );

    const [objips, setObjips] = useState<IPSView>(
        new IPSView(
            0,
            "",
            "",
            false,
            new Municipio(0, "", "", new Deparment(0, "")),
            new Date(),
            false,
            "",
            new Date(), true, true, "", "", new Date()
        )
    );

    // const cleanBox = (form: HTMLFormElement) => {
    //     form.reset();

    //     object.connection = "";
    //     object.password_connection = "";
    //     object.password_server = "";
    //     object.name_server = "";

    //     (form.querySelector('[name="name_solicited"]') as HTMLInputElement).value =
    //         "";
    //     (form.querySelector('[name="role2"]') as HTMLInputElement).value = "";
    //     (form.querySelector('[name="number"]') as HTMLInputElement).value = "";
    //     (form.querySelector('[name="requirement"]') as HTMLInputElement).value = "";

    //     form.classList.remove("was-validated");
    // };

    const getAllIPS = async () => {
        try {
            const results = await ServicePrivate.requestGET(ApiBack.IPS_VIEW_ACTIVE);
            setArrayIPS(results);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching info IPS:", error);
            setLoading(false);
            // handleTokenError(error); // Manejar el error de token
        }
    };
    // Filtrar los datos según búsqueda
    const filteredIps = arrayPacts.filter((pacts) => {
        if (!search) return true; // si no hay búsqueda, no filtramos nada
        const term = search.toLowerCase().trim();
        return (
            pacts.num_certificate.toLowerCase().includes(term)
        );
    });
    const [sortedIps, setSortedIps] = useState(filteredIps);
    const handleTokenError = () => {
        navigate("/");
    };
    const [startDateEntry, setStartDateEntry] = useState<string>("");
    const [endDateEntry, setEndDateEntry] = useState<string>("");
    const getOneIps = async (id: number) => {
        try {
            const urlGetUser = ApiBack.IPS_LIST_ONE + "/" + id;
            const result = await ServicePrivate.requestGET(urlGetUser);
            setObjips(result);
            setShow(true);
        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };

    const getMunicipality = async () => {
        try {
            const urlGetMunc = ApiBack.MUNICIPIOS_LIST;
            const result = await ServicePrivate.requestGET(urlGetMunc);
            setArrayMunicipio(result);
        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };
    const getIPSUpdate = async () => {
        try {
            const urlGetMunc = ApiBack.IPS_UPDATE_STATUS;
            const result = await ServicePrivate.requestGET(urlGetMunc);

            if (result) {
                setArrayIPSUpdate(result);
            }
            if (result.error) {
                MessageToastify("error", result.error, 3000)
            }
        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };

    const handleShowCreate = async () => {
        setShow2(true);
        getMunicipality();

    }

    const getOneIpsUp = async (id: number) => {
        try {
            const urlGetUser = ApiBack.IPS_LIST_ONE + "/" + id;
            const result = await ServicePrivate.requestGET(urlGetUser);
            setObjips(result);
            setShowUpdate(true);
            setDateContract(result.date_contract)
            setDateUpdate2025(result.date_update2025)
            setHaveActialization(result.have_actualization)
            setConnection(result.connection)
            setPasswordConnection(result.password_connection)
            setNameServer(result.name_server)
            setPasswordServer(result.password_server)
            console.log(result);

        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError(); // Manejar el error de token
            }
        }
    };

    const getOneIpsUpDateA = async (id: number) => {
        try {
            const urlGetUser = ApiBack.IPS_LIST_ONE_ACTIVATE + "/" + id;
            const result = await ServicePrivate.requestGET(urlGetUser);
            setObjips(result);
            setShowUpActivation(true);
            setDataA(result.data_a)
        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError(); // Manejar el error de token
            }
        }
    };

    const getOneDataIps = async (id: number) => {
        try {
            const urlGetUser = ApiBack.IPS_LIST_ONE_DATA + "/" + id;
            const result = await ServicePrivate.requestGET(urlGetUser);
            setObjIps(result);
            setShowData(true);
        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError(); // Manejar el error de token
            }
        }
    };

    const getAllConciliation = async () => {
        try {
            const results = await ServicePrivate.requestGET(ApiBack.IPS_VIEW_ALL);

            if (results) {
                const payload = results.data || [];
                const resumen = results.resumen || {};
                setArrayPacts([]);
                setResumen(resumen)
                console.log("Este es el metodo que esta llegando");

            } else {
                setLoading(true);
            }
        } catch (error) {
            console.error("Error fetching IPS:", error);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };


    const getProfessionals = async () => {
        try {
            const token: any = localStorage.getItem("access");
            if (!token) {
                handleTokenError();
                return;
            }
            const decoded: any = jwtDecode(token);

            if (decoded && decoded.role) {
                setArrayUsers(decoded);
                setLoading(false);
                return;
            } else {
                console.error("El token no contiene información de usuario válida.");
                handleTokenError();
            }

        } catch (error) {
            console.error("Error fetching professionals:", error);
            setLoading(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };


    const sendForm = async (fh: formaHtml) => {
        try {
            fh.preventDefault();
            setProcess(true);
            const form = fh.currentTarget;

            form.classList.add("was-validated");

            if (form.checkValidity() === false) {
                fh.preventDefault();
                fh.stopPropagation();
                setProcess(false);
                MessageToastify(
                    "error",
                    "Por favor, completa todos los campos requeridos.",
                    7000
                );
                return;
            }

            const formData = {

            };

            const response = await ServicePrivate.requestPOST(
                ApiBack.IPS_CREATE,
                formData
            );

            if (response.OK) {
                setProcess(false);
                MessageToastify(
                    "error",
                    "error al momento de crear el nuevo cliente.",
                    5000
                );
            } else {
                setProcess(false);
                handleClose2();
                getAllIPS();
                MessageToastify("success", "EL nuevo cliente ha sido creado.", 5000);
            }
        } catch (error) {
            setProcess(false);

            MessageToastify(
                "error",
                "Error en el momento  crear el nuevo cliente.",
                7000
            );
        }
    };

    const handleIpsNameChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setselectedIpsName(event.target.value);
    };

    useEffect(() => {
        getAllIPS();
        getProfessionals();
        getIPSUpdate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (sattendance === "False") {
            setDateCommitment("1800-01-01");
        }
    }, [sattendance])
    return (
        <>
            <div>
                <div className="row">
                    <div className="col-lg-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-6 col-sm-4">
                                        <h4 className="card-title fs-4">
                                            <i className="fa-solid fa-list"></i>&nbsp;Busqueda de pactos
                                        </h4>
                                    </div>
                                    <div className="col-lg-6 col-sm-4">
                                        <div className="d-flex justify-content-center justify-content-md-end py-2 p-md-0">
                                            <button
                                                className={
                                                    "badge fs-6 py-1 pe-2 text-success-emphasis bg-success-subtle border border-success-subtle rounded-pill"
                                                }
                                                type="button"
                                                onClick={() => handleShowCreate()}
                                                style={{ marginLeft: "10px" }}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;Crear
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="d-flex align-items-center col-lg-8 col-md-12">
                                            <Form.Group className="" controlId="formIps">
                                                <Form.Label className="fw-bold">Seleccionar IPS</Form.Label>
                                                <Form.Select
                                                    value={selectedIpsName}
                                                    onChange={handleIpsNameChange}
                                                    onClick={() => {
                                                        //   setArrayAuthDevice([]);
                                                        setPage(0);
                                                        //   setlimit(0);
                                                        //   setTotal(0);
                                                    }}
                                                >
                                                    <option value="">Todas las IPS</option>
                                                    {arrayIPS.map((type) => (
                                                        <option key={type.id} value={type.id}>
                                                            {type.municipio_id.nombre_municipio}&nbsp;-&nbsp;
                                                            {type.nombre_ips}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                            <Form.Group className="" controlId="startDateEntry">
                                                <Form.Label className="fw-bold">Fecha de inicio</Form.Label>
                                                <Form.Control
                                                    required
                                                    type="date"
                                                    // id="startDateEntry"
                                                    value={startDateEntry}
                                                    onChange={(e) => setStartDateEntry(e.target.value)}
                                                    onClick={() => {
                                                        //   setArrayAuthDevice([]);
                                                        setPage(0);
                                                        //   setlimit(0);
                                                        //   setTotal(0);
                                                    }}
                                                />
                                            </Form.Group>
                                            <Form.Group className="" controlId="startDateEntry">
                                                <Form.Label className="fw-bold">Fecha de fin</Form.Label>
                                                <Form.Control
                                                    required
                                                    type="date"
                                                    value={endDateEntry}
                                                    onChange={(e) => setEndDateEntry(e.target.value)}
                                                    onClick={() => {
                                                        //   setArrayAuthDevice([]);
                                                        setPage(0);
                                                        //   setlimit(0);
                                                        //   setTotal(0);
                                                    }}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="d-flex align-items-center mt-lg-4 col-lg-4 col-md-12 mb-3">
                                            <DateFilterButtons
                                                setStartDateEntry={setStartDateEntry}
                                                setEndDateEntry={setEndDateEntry}
                                                setIsSearchTriggered={setIsSearchTriggered}
                                                setPage={setPage}
                                                getMySupports={getAllConciliation}
                                                page={page}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row d-flex justify-center">
                                    <div className="col-lg-2 col-md-2">
                                        <p>
                                            Total de pactos:&nbsp;
                                            <b className="fw-bold">{resumen.total_ips}</b>
                                        </p>

                                    </div>
                                    <div className="col-lg-3 col-md-2">
                                        <p>
                                            Total de pactos el la busqueda:&nbsp;
                                            <b className="fw-bold">{resumen.total_ips}</b>
                                        </p>

                                    </div>
                                </div>

                                <div className="table-responsive rounded-table" style={{
                                    maxHeight: "70vh",
                                    overflowY: "auto",
                                    zIndex: 1020
                                }}>

                                    <table className="table table-striped table-sm table-hover table-sm">
                                        <thead className="table-dark " style={{ position: "sticky", top: 0, zIndex: 10 }}>
                                            <tr>
                                                <th style={{ width: "5%", cursor: "pointer" }} >Conciliacion</th>
                                                <th style={{ width: "25%" }}>Fecha reunion</th>
                                                <th style={{ width: "25%" }}>Asistencia</th>
                                                <th style={{ width: "10%" }}>Número de acta</th>
                                                <th style={{ width: "15%" }}>Acuerdo</th>
                                                <th style={{ width: "15%" }}>Fecha de acuerdo</th>
                                                <th style={{ width: "18%" }}>Tipo deuda</th>
                                                <th style={{ width: "12%" }}>Valor pagado</th>
                                                <th style={{ width: "12%" }}>Monto conciliar erp</th>
                                                <th style={{ width: "12%" }}>Monto conciliar ebp</th>
                                                <th style={{ width: "12%" }}>Glosa aceptada ebp</th>
                                                <th style={{ width: "12%" }}>Glosa subsanada erp</th>
                                                <th style={{ width: "12%" }}>Glosa no resuelta</th>
                                                <th style={{ width: "12%" }}>Valor conciliado</th>
                                                <th style={{ width: "12%" }}>Fecha compromiso</th>
                                                <th style={{ width: "12%" }}>Valor pagar</th>
                                            </tr>
                                        </thead>
                                        <tbody className="table-group-divider ">
                                            {(sortedIps.length > 0 ? sortedIps : filteredIps).map((myCreditor, count) => (
                                                <tr key={count + 1}>
                                                    <td>{myCreditor.id_conciliation}</td>
                                                    <td>{myCreditor.date_pact}</td>
                                                    <td>{myCreditor.attendance}</td>
                                                    <td>{myCreditor.num_certificate}</td>
                                                    <td>{myCreditor.agreement}</td>
                                                    <td>{myCreditor.date_agreement}</td>
                                                    <td>{myCreditor.type_debt}</td>
                                                    <td>{myCreditor.value_pact}</td>
                                                    <td>{myCreditor.reconciliation_amount_erp}</td>
                                                    <td>{myCreditor.reconciliation_amount_ebp}</td>
                                                    <td>{myCreditor.gloss_acepted_ebp}</td>
                                                    <td>{myCreditor.gloss_corrected_erp}</td>
                                                    <td>{myCreditor.gloss_unresolved}</td>
                                                    <td>{myCreditor.value_reconciled}</td>
                                                    <td>{myCreditor.date_commitment_payment}</td>
                                                    <td>{myCreditor.value_payment}</td>
                                                    <td>
                                                        <button
                                                            className={`badge fs-6 align-items-center p-1 pe-1 rounded-pill border ${myCreditor.is_active
                                                                ? "text-info-emphasis bg-info-subtle border-info-subtle"
                                                                : "text-secondary bg-secondary-subtle border-secondary"
                                                                }`}
                                                            onClick={() => getOneDataIps(myCreditor.id)}
                                                            disabled={!myCreditor.is_active}
                                                        >
                                                            <i className="fa-solid fa-info"></i>
                                                        </button>
                                                        &nbsp;
                                                        <button
                                                            className={`badge fs-6 align-items-center p-1 pe-1 rounded-pill border ${myCreditor.is_active
                                                                ? "text-dark-emphasis bg-dark-subtle border-dark-subtle"
                                                                : "text-secondary bg-secondary-subtle border-secondary"
                                                                }`}
                                                            onClick={() => getOneIpsUp(myCreditor.id)}
                                                            disabled={!myCreditor.is_active}
                                                        >
                                                            <i className="fa-solid fa-pen-to-square"></i>
                                                        </button>
                                                        &nbsp;
                                                        <button
                                                            className={`badge fs-6 align-items-center p-1 pe-1 rounded-pill border ${myCreditor.is_active
                                                                ? "text-primary-emphasis bg-primary-subtle border-primary-subtle"
                                                                : "text-secondary bg-secondary-subtle border-secondary"
                                                                }`}
                                                            onClick={() => getOneIpsUpDateA(myCreditor.id)}
                                                            disabled={!myCreditor.is_active}
                                                        >
                                                            <i className="fa-solid fa-a"></i>
                                                        </button>
                                                        &nbsp;
                                                        {arrayUsers?.role === "ADMINISTRADOR" ? (
                                                            <>
                                                                <button
                                                                    className={
                                                                        myCreditor.is_active
                                                                            ? "badge fs-6 py-1 pe-1 text-danger-emphasis bg-danger-subtle border border-danger-subtle rounded-pill"
                                                                            : "badge fs-6 py-1 pe-3 text-success-emphasis bg-success-subtle border border-success-subtle rounded-pill"
                                                                    }
                                                                    type="button"
                                                                    onClick={() => getOneIps(myCreditor.id)}

                                                                >
                                                                    {myCreditor.is_active ? (
                                                                        <>
                                                                            <i className="fa-regular fa-circle-xmark"></i>
                                                                            &nbsp;Inactivar
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <i className="fa-regular fa-circle-check"></i>
                                                                            &nbsp;Activar
                                                                        </>
                                                                    )}
                                                                </button>
                                                            </>
                                                        ) : ("")}

                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="d-flex align-items-center justify-content-center m-3"></div>
                                </div>


                                <Modal
                                    show={showData}
                                    onHide={handleCloseData}
                                    backdrop="static"
                                    keyboard={false}
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                    size="xl"
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title className="text-center fw-bold">
                                            Datos de la ips
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Card className="mt-0 border-0 shadow-none">
                                            {/* card body */}
                                            <Card.Body>
                                                {/* card title */}
                                                <Card.Title
                                                    as="h4"
                                                    className="d-flex justify-content-center fs-2"
                                                >
                                                    <i className="fa-solid fa-hospital-user"></i>
                                                    &nbsp;IPS
                                                </Card.Title>
                                                <span
                                                    className="text-uppercase fw-lighter  fs-6 ls-2"
                                                    style={{ color: "#0f0f70" }}
                                                >
                                                    <i className="fa-solid fa-clipboard-check"></i> Nombre de la ips:{" "}
                                                    <p className="fw-semibold text-black fs-5">
                                                        {objIps?.nombre_ips}
                                                    </p>
                                                </span>
                                                <Row>
                                                    <Col xs={8} className="mb-1">
                                                        <h6
                                                            className="text-uppercase fs-6 fw-lighter ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-regular fa-id-card"></i> Código Ips
                                                        </h6>
                                                        <p className="fw-semibold fs-5 text-black">
                                                            {objIps?.cod_ips}
                                                        </p>
                                                    </Col>
                                                    <Col xs={4} className="mb-1">
                                                        <h6
                                                            className="text-uppercase fs-6 fw-lighter ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-solid fa-calendar"></i> Contrato S/C
                                                        </h6>
                                                        <p className="fw-semibold fs-5 text-black">
                                                            {objIps?.date_contract
                                                                ? new Date(`${objIps.date_contract}T00:00:00`).toLocaleString(
                                                                    "es-CO",
                                                                    {
                                                                        year: "numeric",
                                                                        month: "2-digit",
                                                                        day: "2-digit",
                                                                    }
                                                                )
                                                                : "No Tiene contrato"}
                                                        </p>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <h6
                                                            className="text-uppercase fw-lighter fs-6 ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-regular fa-envelope"></i> Fecha de actualización y actualizado
                                                        </h6>
                                                        <p className="fw-semibold fs-5 text-black">
                                                            {objIps?.date_update2025
                                                                ? new Date(`${objIps.date_contract}T00:00:00`).toLocaleString(
                                                                    "es-CO",
                                                                    {
                                                                        year: "numeric",
                                                                        month: "2-digit",
                                                                        day: "2-digit",
                                                                    }
                                                                )
                                                                : "No Tiene actualización"}&nbsp;
                                                            {objIps?.date_updated
                                                                ? new Date(`${objIps.date_updated}T00:00:00`).toLocaleString(
                                                                    "es-CO",
                                                                    {
                                                                        year: "numeric",
                                                                        month: "2-digit",
                                                                        day: "2-digit",
                                                                    }
                                                                )
                                                                : "No Tiene actualizada"}
                                                        </p>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <h6
                                                            className="text-uppercase fw-lighter fs-6 ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-regular fa-envelope"></i> Conexión
                                                        </h6>
                                                        <p className="text-uppercase fw-semibold fs-5 text-black">
                                                            {objIps?.connection}
                                                        </p>
                                                    </Col>
                                                    <Col xs={6} className="mb-1">
                                                        <h6
                                                            className="text-uppercase fw-lighter fs-6 ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-solid fa-phone-volume"></i> Contraseña de la conexión
                                                        </h6>
                                                        <p className="fw-semibold fs-5 text-black">
                                                            {objIps?.password_connection}
                                                        </p>
                                                    </Col>
                                                    <Col xs={6} className="mb-1">
                                                        <h6
                                                            className="text-uppercase fw-lighter fs-6 ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-solid fa-phone-volume"></i> Nombre del servidor
                                                        </h6>
                                                        <p className="fw-semibold fs-5 text-black">
                                                            {objIps?.name_server}
                                                        </p>
                                                    </Col>
                                                    <Col xs={12}>
                                                        <h6
                                                            className="text-uppercase fw-lighter fs-6 ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-regular fa-envelope"></i> Contraseña del servidor
                                                        </h6>
                                                        <p className="text-uppercase fw-semibold fs-5 text-black">
                                                            {objIps?.password_server}
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button
                                            variant="danger"
                                            onClick={() => {
                                                setShowData(false);
                                            }}
                                        >
                                            <i className="fa-solid fa-backward"></i>
                                            &nbsp;Cerrar
                                        </Button>
                                    </Modal.Footer>
                                </Modal>


                                <Modal
                                    show={show2}
                                    onHide={handleClose2}
                                    backdrop="static"
                                    keyboard={false}
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                    size="xl"
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title className="text-center fw-bold">
                                            <i className="fa-solid fa-folder-plus"></i>
                                            &nbsp;Formulario de creación
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Form
                                        className="forms-sample"
                                        validated={process}
                                        onSubmit={sendForm}
                                        noValidate
                                        ref={formRef}
                                    >
                                        <Modal.Body>
                                            {/* Campo para nombre_ips */}
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <Form.Group controlId="date_pact" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="date_pact"
                                                        >
                                                            Fecha del pacto:
                                                        </Form.Label>

                                                        <Form.Control
                                                            required
                                                            type="date"
                                                            name="date_pact"
                                                            className="form-control"
                                                            id="date_pact"
                                                            placeholder="Escriba el tipo de acreedor"
                                                            value={date_pact}
                                                            onChange={(e) => {
                                                                doubleLink(e);
                                                                // setDateC(e.target.value);
                                                            }}
                                                            // readOnly={sattendance === "False"}
                                                            autoComplete="off"
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            La fecha del pacto es obligatorio.
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-3">
                                                    {/* Campo para cod_ips */}
                                                    <Form.Group controlId="id_conciliation" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="id_conciliation"
                                                        >
                                                            Conciliación:
                                                        </Form.Label>

                                                        <>
                                                            <Form.Select
                                                                required
                                                                id="id_conciliation"
                                                                name="id_conciliation"
                                                                value={id_conciliation}
                                                                onChange={doubleLink}
                                                            >
                                                                <option value="">Seleccione la conciliacion</option>
                                                                <option value="True">Presencial</option>
                                                                <option value="False">Virtual</option>
                                                                {sprogramming === "False" && (
                                                                    <option value="No aplica">No aplica</option>
                                                                )}

                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">
                                                                El tipo de acreedor es obligatorio.
                                                            </Form.Control.Feedback>
                                                        </>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-3">

                                                    <Form.Group controlId="sattendance" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="sattendance"
                                                        >
                                                            Asistencia:
                                                        </Form.Label>

                                                        <>
                                                            <Form.Select
                                                                required
                                                                id="sattendance"
                                                                name="sattendance"
                                                                value={sattendance}
                                                                onChange={(e) => {
                                                                    doubleLink(e);
                                                                    setSattendance(e.target.value);
                                                                    setSattendanceBool(e.target.value === "True");
                                                                }}
                                                            >
                                                                <option value="">Seleccione la asistencia</option>
                                                                <option value="True">Si</option>
                                                                <option value="False">No</option>

                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">
                                                                La asistencia es obligatorio.
                                                            </Form.Control.Feedback>
                                                        </>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-3">
                                                    <Form.Group controlId="num_certificate" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="num_certificate"
                                                        >
                                                            Número de acta:
                                                        </Form.Label>
                                                        <Form.Control
                                                            required
                                                            type="text"
                                                            name="num_certificate"
                                                            className="form-control"
                                                            id="num_certificate"
                                                            placeholder="Escriba el número del acta"
                                                            value={num_certificate}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Permitir solo números y limitar a 20 caracteres
                                                                if (/^\d*$/.test(value) && value.length <= 20) {
                                                                    doubleLink(e); // Llama a tu función existente
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={20} // Limita a 20 caracteres
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            El número de acta es obligatorio.
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-3">
                                                    <Form.Group controlId="agreement" className="mb-3 w-100">
                                                    <Form.Label
                                                        className="fw-bold mb-2 mt-2"
                                                        htmlFor="agreement"
                                                    >
                                                        Acuerdo:
                                                    </Form.Label>
                                                    <Form.Select
                                                        required
                                                        id="agreement"
                                                        name="agreement"
                                                        value={agreement}
                                                        onChange={doubleLink}
                                                    >
                                                        <option value="">Seleccione el acuerdo</option>
                                                        <option value="True">Si</option>
                                                        <option value="False">No</option>

                                                    </Form.Select>
                                                </Form.Group></div>
                                                <div className="col-lg-6">
                                                    <Form.Group controlId="date_agreement" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="date_agreement"
                                                        >
                                                            Fecha de acuerdo:
                                                        </Form.Label>
                                                        <Form.Control
                                                            required
                                                            type="date"
                                                            name="date_agreement"
                                                            className="form-control"
                                                            id="date_agreement"
                                                            placeholder="Escriba la glosa de la conciliación"
                                                            value={date_agreement}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Permitir solo números y limitar a 20 caracteres
                                                                if (/^\d*$/.test(value) && value.length <= 20) {
                                                                    doubleLink(e); // Llama a tu función existente
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={20}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">
                                                    <Form.Group controlId="type_debt" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="type_debt"
                                                        >
                                                            Tipo de deuda:
                                                        </Form.Label>
                                                        <Form.Select
                                                            required
                                                            id="agreement"
                                                            name="agreement"
                                                            value={agreement}
                                                            onChange={doubleLink}
                                                        >
                                                            <option value="">Seleccione la conciliacion</option>
                                                            <option value="True">UPC Régimen Subsidiado</option>
                                                            <option value="False">UPC Régimen Contributivo</option>
                                                            <option value="False">UPC Régimen Contributivo</option>
                                                            <option value="False">Presupuestos máximos</option>
                                                            <option value="False">No UPC, ni presupuestos máximos</option>
                                                            <option value="False">Población no afiliada</option>
                                                            <option value="False">Salud Pública</option>
                                                            <option value="False">Población Migrantes</option>

                                                        </Form.Select>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-3"><Form.Group controlId="reconciliation_amount_erp" className="mb-3 w-100">
                                                    <Form.Label
                                                        className="fw-bold mb-2 mt-2"
                                                        htmlFor="reconciliation_amount_erp"
                                                    >
                                                        Monto a conciliar erp:
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="reconciliation_amount_erp"
                                                        className="form-control"
                                                        id="reconciliation_amount_erp"
                                                        placeholder="Escriba el monto a conciliar erp"
                                                        value={sattendanceBool ? reconciliation_amount_erp : "0"}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            // Permitir solo números y limitar a 20 caracteres
                                                            if (/^\d*$/.test(value) && value.length <= 20) {
                                                                doubleLink(e); // Llama a tu función existente
                                                            }
                                                        }}
                                                        autoComplete="off"
                                                        maxLength={15}
                                                        disabled={!sattendanceBool}
                                                    />
                                                </Form.Group></div>
                                                <div className="col-lg-3">

                                                    <Form.Group controlId="reconciliation_amount_ebp" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="reconciliation_amount_ebp"
                                                        >
                                                            Monto a conciliar ebp:
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="reconciliation_amount_ebp"
                                                            className="form-control"
                                                            id="reconciliation_amount_ebp"
                                                            placeholder="Escriba el monto a conciliar ebp"
                                                            value={sattendanceBool ? reconciliation_amount_erp : "0"}
                                                            onChange={(e) => {
                                                                if (!sattendance) return;
                                                                const value = e.target.value;
                                                                if (/^\d*$/.test(value) && value.length <= 20) {
                                                                    doubleLink(e);
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={15}
                                                            disabled={!sattendanceBool}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-3">
                                                    <Form.Group controlId="gloss_acepted_ebp" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="gloss_acepted_ebp"
                                                        >
                                                            Glosa aceptada ebp:
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="gloss_acepted_ebp"
                                                            className="form-control"
                                                            id="gloss_acepted_ebp"
                                                            placeholder="Escriba la glosa aceptada ebp"
                                                            value={sattendanceBool ? gloss_acepted_ebp : "0"}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Permitir solo números y limitar a 20 caracteres
                                                                if (/^\d*$/.test(value) && value.length <= 20) {
                                                                    doubleLink(e); // Llama a tu función existente
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={15}
                                                            disabled={!sattendanceBool}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-3">
                                                    <Form.Group controlId="gloss_corrected_erp" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="gloss_corrected_erp"
                                                        >
                                                            Glosa subsanada erp:
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="gloss_corrected_erp"
                                                            className="form-control"
                                                            id="gloss_corrected_erp"
                                                            placeholder="Escriba la glosa subsanada erp"
                                                            value={sattendanceBool ? gloss_corrected_erp : "0"}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Permitir solo números y limitar a 20 caracteres
                                                                if (/^\d*$/.test(value) && value.length <= 20) {
                                                                    doubleLink(e); // Llama a tu función existente
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={15}
                                                            disabled={!sattendanceBool}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-3">
                                                    <Form.Group controlId="gloss_unresolved" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="gloss_unresolved"
                                                        >
                                                            Glosa no resuelta:
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="gloss_unresolved"
                                                            className="form-control"
                                                            id="gloss_unresolved"
                                                            placeholder="Escriba la glosa no resuelta"
                                                            value={sattendanceBool ? gloss_unresolved : "0"}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Permitir solo números y limitar a 20 caracteres
                                                                if (/^\d*$/.test(value) && value.length <= 20) {
                                                                    doubleLink(e); // Llama a tu función existente
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={15}
                                                            disabled={!sattendanceBool}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-3">
                                                    <Form.Group controlId="value_reconciled" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="value_reconciled"
                                                        >
                                                            Valor conciliado:
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="value_reconciled"
                                                            className="form-control"
                                                            id="value_reconciled"
                                                            placeholder="Escriba el valor conciliado"
                                                            value={sattendanceBool ? value_reconciled : "0"}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Permitir solo números y limitar a 20 caracteres
                                                                if (/^\d*$/.test(value) && value.length <= 20) {
                                                                    doubleLink(e); // Llama a tu función existente
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={15}
                                                            disabled={!sattendanceBool}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">

                                                    <Form.Group controlId="date_commitment_payment" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="date_commitment_payment"
                                                        >
                                                            Fecha compromiso:
                                                        </Form.Label>
                                                        {sattendance === "False" ? (
                                                            <p className="text-secondary fst-italic">
                                                                No tiene programación, por lo tanto la fecha de conciliación se establece en 1800-01-01
                                                            </p>
                                                        ) : (
                                                            <>
                                                                <Form.Control
                                                                    required
                                                                    type="date"
                                                                    name="date_commitment_payment"
                                                                    className="form-control"
                                                                    id="date_commitment_payment"
                                                                    placeholder="Escriba el tipo de acreedor"
                                                                    value={date_commitment_payment}
                                                                    onChange={(e) => {
                                                                        doubleLink(e);
                                                                        setDateCommitment(e.target.value);
                                                                    }}
                                                                    readOnly={sprogramming === "False"}
                                                                    autoComplete="off"
                                                                />
                                                                <Form.Control.Feedback type="invalid">
                                                                    El tipo de acreedor es obligatorio.
                                                                </Form.Control.Feedback>
                                                            </>)}
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">

                                                    <Form.Group controlId="value_payment" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="value_payment"
                                                        >
                                                            Valor a pagar:
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="value_payment"
                                                            className="form-control"
                                                            id="value_payment"
                                                            placeholder="Escriba el valor a pagar"
                                                            value={sattendanceBool ? value_payment : "0"}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Permitir solo números y limitar a 20 caracteres
                                                                if (/^\d*$/.test(value) && value.length <= 20) {
                                                                    doubleLink(e); // Llama a tu función existente
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={15}
                                                            disabled={!sattendanceBool}
                                                        />
                                                    </Form.Group>
                                                </div>
                                            </div>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="danger" onClick={handleClose2}>
                                                <i className="fa-solid fa-backward"></i>&nbsp;Cancelar
                                            </Button>
                                            <Button
                                                variant="success"
                                                type="submit"
                                                onClick={() => { }}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;Guardar
                                            </Button>
                                        </Modal.Footer>
                                    </Form>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </div>
        </>
    );
};
